class VivicatCustomerReviews extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-vivicat-reviews-grid]');
    this.cards = Array.from(this.querySelectorAll('[data-vivicat-review-card]'));
    this.filterButtons = Array.from(this.querySelectorAll('[data-vivicat-review-filter]'));
    this.sortSelect = this.querySelector('[data-vivicat-review-sort]');
    this.loadMoreButton = this.querySelector('[data-vivicat-review-load-more]');
    this.modal = this.querySelector('[data-vivicat-review-modal]');
    this.modalImage = this.querySelector('[data-vivicat-review-modal-image]');
    this.modalAuthor = this.querySelector('[data-vivicat-review-modal-author]');
    this.modalDate = this.querySelector('[data-vivicat-review-modal-date]');
    this.modalBody = this.querySelector('[data-vivicat-review-modal-body]');
    this.modalStars = this.querySelector('.vivicat-review-modal .vivicat-review-stars');
    this.visibleLimit = Number(this.dataset.initialCount || 8);
    this.increment = Number(this.dataset.increment || 8);
    this.activeFilter = 'all';
    this.lastFocused = null;

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => this.setFilter(button.dataset.vivicatReviewFilter));
    });
    this.sortSelect?.addEventListener('change', () => this.applyState(true));
    this.loadMoreButton?.addEventListener('click', () => {
      this.visibleLimit += this.increment;
      this.applyState(false);
    });
    this.querySelectorAll('[data-vivicat-review-open]').forEach((button) => {
      button.addEventListener('click', () => this.openModal(button));
    });
    this.modal?.querySelectorAll('[data-vivicat-review-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeModal());
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeModal();
    });

    this.applyState(true);
  }

  setFilter(filter) {
    this.activeFilter = filter || 'all';
    this.visibleLimit = Number(this.dataset.initialCount || 8);
    this.filterButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.vivicatReviewFilter === this.activeFilter);
    });
    this.applyState(true);
  }

  matchingCards() {
    return this.cards.filter((card) => {
      if (this.activeFilter === 'photos') return card.dataset.hasPhoto === 'true';
      if (this.activeFilter.startsWith('rating-')) {
        return Number(card.dataset.rating) === Number(this.activeFilter.replace('rating-', ''));
      }
      return true;
    });
  }

  sortedCards(cards) {
    const sort = this.sortSelect?.value || 'newest';
    return [...cards].sort((a, b) => {
      const ratingA = Number(a.dataset.rating || 0);
      const ratingB = Number(b.dataset.rating || 0);
      const dateA = Number(a.dataset.date || 0);
      const dateB = Number(b.dataset.date || 0);

      if (sort === 'highest') return ratingB - ratingA || dateB - dateA;
      if (sort === 'lowest') return ratingA - ratingB || dateB - dateA;
      return dateB - dateA;
    });
  }

  applyState(reorder) {
    const sorted = this.sortedCards(this.matchingCards());
    const visible = new Set(sorted.slice(0, this.visibleLimit));

    if (reorder && this.grid) {
      sorted.forEach((card) => this.grid.appendChild(card));
    }

    this.cards.forEach((card) => {
      card.hidden = !visible.has(card);
    });

    if (this.loadMoreButton) {
      this.loadMoreButton.parentElement.hidden = sorted.length <= this.visibleLimit;
    }
  }

  openModal(button) {
    if (!this.modal || !this.modalImage) return;

    this.lastFocused = button;
    this.modalImage.src = button.dataset.fullSrc;
    this.modalImage.alt = button.dataset.fullAlt || '';
    this.modalAuthor.textContent = button.dataset.author || '';
    this.modalDate.textContent = button.dataset.date || '';
    this.modalBody.textContent = button.dataset.body || '';

    const rating = Number(button.dataset.rating || 0);
    this.modalStars?.style.setProperty('--vivicat-review-rating', `${Math.max(0, Math.min(5, rating)) * 20}%`);

    this.modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    this.modal.querySelector('[data-vivicat-review-close]')?.focus();
  }

  closeModal() {
    if (!this.modal || this.modal.hidden) return;

    this.modal.hidden = true;
    this.modalImage.removeAttribute('src');
    document.documentElement.classList.remove('overflow-hidden');
    this.lastFocused?.focus();
  }
}

customElements.define('vivicat-customer-reviews', VivicatCustomerReviews);
